import React, { useRef, useEffect, useState } from "react";

interface NavbarDropdownProps {
  icon: React.ReactNode;
  children: React.ReactNode;
  className?: string;
  isOpen?: boolean;
  onToggle?: () => void;
}

const NavbarDropdown: React.FC<NavbarDropdownProps> = ({
  icon,
  children,
  className,
  isOpen: isOpenProp,
  onToggle,
}) => {
  const [isOpen, setIsOpen] = useState(
    isOpenProp !== undefined ? isOpenProp : false
  );
  const [iconColor, setIconColor] = useState("");
  const dropdownRef = useRef<HTMLDivElement>(null);

  const toggleDropdown = () => {
    // Toggle internal state and icon color
    const newState = !isOpen;
    setIconColor(newState ? "opened-color" : "");
    // Call onToggle callback from parent if provided
    if (onToggle) { onToggle(); }
    else { setIsOpen(newState); }
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        if (isOpen) {
          if (onToggle) { onToggle(); }
          else { setIsOpen(false); }
          setIconColor("");
        }
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen, onToggle]);


  // Synchronize internal state with parent-controlled isOpen prop
  useEffect(() => {
    if (isOpenProp !== undefined && isOpenProp !== isOpen) {
      setIsOpen(isOpenProp);
      setIconColor(isOpenProp ? "opened-color" : "");
    }
    //eslint-disable-next-line
  }, [isOpenProp]);

  return (
    <div className="dropdown" ref={dropdownRef}>
      <div
        onClick={toggleDropdown}
        className={`icon-box ${iconColor}`}
        role="button"
        aria-expanded={isOpen}
      >
        {icon}
      </div>
      {isOpen && (
        <div className={`navdropdown-content dropdown-content navdrop ${className}`} role="menu">
          {children}
        </div>
      )}
    </div>
  );
};

export default NavbarDropdown;
